import axios from 'axios';

// Types
export const FETCH_LISTS = 'FETCH_LISTS';
// export const FETCH_LIST = 'FETCH_LIST';

export const fetchLists = () => {
	let url = '';

	if (process.env.NODE_ENV === 'production') {
		url = `https://nivea-marlies-checklist-api.herokuapp.com/lists`;
	} else {
		url = 'http://localhost:5000/lists';
	}
	const request = axios.get(url);

	return {
		type: FETCH_LISTS,
		payload: request // we're returning a Promise here
	};
};

// export const fetchList = (listId) => {

//     const url = `https://nivea-marlies-checklist-api.herokuapp.com/list?id=${listId}`;
//     const request = axios.get(url);

//     return {
//         type: FETCH_LIST,
//         payload: request // we're returning a Promise here
//     }
// }



// WEBPACK FOOTER //
// ./src/actions/actions_lists.js